import { Dispatch } from 'redux'
import { useSelector, useDispatch } from 'react-redux'
import {
	addLoading,
	hideIconMenu,
	removeLoading,
} from '../../../../shared/Infraestructure/SliceGenerico'
import { AdapterGenerico } from '../../../../shared/Infraestructure/AdapterGenerico'
import { useEffect, useState } from 'react'
import { UseCaseSelectTrabajosLocal } from '../Application/UseCaseSelectTrabajosLocal'
import { AdapterConfigure } from './AdapterConfigure'
import { RepositoryImplMain } from './RepositoryImplMain'
import { RootState } from '../../../../shared/Infraestructure/AdapterStore'
import { UseCaseSearchTrabajos } from '../Application/UseCaseSearchTrabajos'
import { changeTextSearch } from './SliceTrabajosDE'
import { UseCaseSelectTrabajos } from '../Application/UseCaseSelectTrabajos'
import { DtoTrabajosDE } from '../Domain/DtoTrabajosDE'
import { LanguageTranslate } from '../../../../shared/Infraestructure/LanguageTranslate'

export const Controller = () => {

	const dispatch: Dispatch = useDispatch()
	const { user } = useSelector((state: RootState) => state.auth)
	const repository = new RepositoryImplMain( dispatch, AdapterConfigure.SCHEMA, AdapterConfigure.ENTITY)
	const [showOffCanvas, setShowOffCanvas] = useState<boolean>(false)
	const [dataTrabajos, setDataTrabajos] = useState<DtoTrabajosDE[]>([])
	const [trabajos, setTrabajos] = useState<DtoTrabajosDE[]>([])
	useEffect(() => setTrabajos(dataTrabajos), [dataTrabajos])
	const languageTranslate = LanguageTranslate();

	const init = async () => {
		try {
			dispatch(hideIconMenu())
			dispatch(addLoading({ textLoading: languageTranslate.general.Buscando_Trabajos }))
			const trabajos = await new UseCaseSelectTrabajosLocal(repository).exec(user)
			setDataTrabajos(trabajos)
		} catch (error) {
			console.error(error)
			AdapterGenerico.createMessage(languageTranslate.general.Alerta, (error as Error).message, 'error')
		} finally {
			dispatch(removeLoading())
		}
	}

	const handleSearch = async (text: string) => {
		try {
			dispatch(addLoading({ textLoading: languageTranslate.general.Buscando_Trabajos }))
			const trabajos = await new UseCaseSearchTrabajos(repository).exec(user, text)
			if (!trabajos.length) AdapterGenerico.createToast(`${languageTranslate.general.Sin_resultados_para} ${text}`, 'info')
			setDataTrabajos(trabajos)
		} catch (error) {
			console.error(error)
			AdapterGenerico.createMessage(languageTranslate.general.Error, (error as Error).message, 'error')
		} finally {
			dispatch(removeLoading())
		}
	}

	const handleChange = (text: string) => {
		try {
			dispatch(changeTextSearch(text))
		} catch (error) {
			console.error(error)
			AdapterGenerico.createMessage(languageTranslate.general.Error, (error as Error).message, 'error')
		}
	}

	const handleRefresh = async () => {
		try {
			dispatch(addLoading({ textLoading: languageTranslate.general.Cargando_trabajos }))
			const trabajos = await new UseCaseSelectTrabajos(repository).exec(user)
			setDataTrabajos(trabajos)
		} catch (error) {
			console.error(error)
			AdapterGenerico.createMessage(languageTranslate.general.Error, (error as Error).message, 'error')
		} finally {
			dispatch(removeLoading())
		}
	}

	return {
		init,
		handleSearch,
		handleChange,
		trabajos,
		showOffCanvas,
		setShowOffCanvas,
		handleRefresh
	}
}
